import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whiteboard-loader',
  templateUrl: './whiteboard-loader.component.html',
  styleUrls: ['./whiteboard-loader.component.css']
})
export class WhiteboardLoaderComponent implements OnInit {

  constructor() {}

  public ngOnInit(): void {}

}
